import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import PageviewIcon from '@material-ui/icons/Pageview';
import RotateIcon from '@material-ui/icons/Rotate90DegreesCcw';

import EventSlide from '../../dashboard/slides/EventSlide';
import ImageSlide from '../../dashboard/slides/ImageSlide';
import SpocEventSlide from '../../dashboard/slides/SpocEventSlide';
import SpocImageSlide from '../../dashboard/slides/SpocImageSlide';
import {Footer, Header} from '../../dashboard/';
import {VideoFrame} from '../../common';

import {getDetails} from '../../../util/eventHelper';

import {SLIDE_TYPES} from '../../../constants/slideTypes';
import { Checkbox } from '@material-ui/core';

class EventPreviewButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.toggleViewMode = this.toggleViewMode.bind(this);
        this.toggleSpocMode = this.toggleSpocMode.bind(this);

        this.state = {
            isPortrait: props.orientation === 'portrait',
            isSpoc: false,
            open: false
        };
    }

    handleClose(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({open: false});
    }

    handleOpen(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({open: true});
    }

    toggleViewMode(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({isPortrait: !this.state.isPortrait});
    }

    toggleSpocMode(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({isSpoc: !this.state.isSpoc});
    }

    render() {
        const isPortait = this.state.isPortrait && !this.state.isSpoc;
        const isLandscape = !this.state.isPortrait && !this.state.isSpoc;
        const {data, graphEvents} = this.props;
        const dialogClass = classNames({
            'preview-dialog': true,
            'landscape': isLandscape,
            'portrait': isPortait,
            'spoc': this.state.isSpoc,
        });
        const containerClass = classNames({
            'preview-container': true,
            'landscape': isLandscape,
            'portrait': isPortait,
            'spoc': this.state.isSpoc,
        });
        const dialogContentClass = classNames({
            'preview-dialog-content': true,
            'landscape': isLandscape,
            'portrait': isPortait,
            'spoc': this.state.isSpoc,
        });
        const dashboardClass = classNames({
            dashboard: !this.state.isSpoc,
            'dashboard-spoc': this.state.isSpoc,
        });
        const previewData = data.calendarEvent ? getDetails(_.clone(data), graphEvents) : data;
        _.set(previewData, 'imageSettings', previewData.imageSettingsFields);
        _.unset(previewData, 'imageSettingsFields');

        return (
            <Button onClick={this.state.open ? null : this.handleOpen}>
                <PageviewIcon/>
                <FormattedMessage id="eventPreview.button"/>
                <Dialog
                    PaperProps={{className: dialogClass}}
                    onClose={this.handleClose}
                    open={this.state.open}
                >
                    <DialogTitle>
                        <FormattedMessage id="eventPreview.title"/>
                    </DialogTitle>
                    <DialogContent className={dialogContentClass}>
                        <div className={containerClass}>
                            <div className={dashboardClass}>
                                { !this.state.isSpoc && <Header/> }
                                <div className="slideshow">
                                    {do {
                                        if (data.type === SLIDE_TYPES.DEFAULT.key) {
                                            this.state.isSpoc ? <SpocEventSlide active {...previewData} duration={null} /> : <EventSlide active {...previewData} duration={null} />;
                                        } else if (data.type === SLIDE_TYPES.IMAGE.key) {
                                            this.state.isSpoc ? <SpocImageSlide active {...previewData} duration={null} /> : <ImageSlide active {...previewData} duration={null} />;
                                        }
                                    }}
                                </div>
                                {do {
                                    if (this.props.enableVideo) {
                                        <VideoFrame videos={{preview: {url: 'https://www.youtube.com/watch?v=1Kl4rNUTWCA'}}}/>;
                                    }
                                }}
                                { !this.state.isSpoc && <Footer /> }
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleViewMode}>
                            <RotateIcon onClick={this.toggleViewMode}/>
                            <FormattedMessage id="eventPreview.rotate"/>
                        </Button>
                        <Button onClick={this.toggleSpocMode}>
                            <Checkbox checked={this.state.isSpoc} />
                            <FormattedMessage id="eventPreview.spoc"/>
                        </Button>
                        <Button onClick={this.handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Button>
        );
    }
}

EventPreviewButton.propTypes = {
    data: PropTypes.object,
    disabled: PropTypes.bool,
    enableVideo: PropTypes.bool
};

export default EventPreviewButton;


// WEBPACK FOOTER //
// ./src/components/common/button/EventPreviewButton.js